<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hHL7xN/tc-custom/9780062329172.jpg?1718283646967" alt="This image is the cover for the book My Life with Earth, Wind & Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Life with Earth, Wind & Fire
      </h1>
      <p class="bookDescription body article font2">
        <p> With an introduction by Steve Harvey and a foreword by David Foster </p><p> The Grammy-winning founder of the legendary pop/R&amp;B/soul/funk/disco group tells his story and charts the rise of his legendary band in this sincere memoir that captures the heart and soul of an artist whose groundbreaking sound continues to influence music today. </p><p> With its dynamic horns, contrasting vocals, and vivid stage shows, Earth, Wind &amp; Fire was one of the most popular acts of the late twentieth century—the band “that changed the sound of black pop” (<i>Rolling Stone</i>)—and its music continues to inspire modern artists including Usher, Jay-Z, Cee-Lo Green, and Outkast. At last, the band’s founder, Maurice White, shares the story of his success. </p><p> Now in his seventies, White reflects on the great blessings music has brought to his life and the struggles he’s endured: his mother leaving him behind in Memphis when he was four; learning to play the drums with Booker T. Jones; moving to Chicago at eighteen and later Los Angeles after leaving the Ramsey Lewis Trio; forming EWF, only to have the original group fall apart; working with Barbra Streisand and Neil Diamond; his diagnosis of Parkinson’s; and his final public performance with the group at the 2006 Grammy Awards. Through it all, White credits his faith for his amazing success and guidance in overcoming his many challenges. </p><p><i>Keep Your Head to the Sky</i> is an intimate, moving, and beautiful memoir from a man whose creativity and determination carried him to great success, and whose faith enabled him to savor every moment. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maurice White, Herb Powell, Steve Harvey, David Foster
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c174fb5